import { Typography } from "@mui/material";
import * as DecisionBaseModal from "components/pages/game/decision-modals/DecisionBaseModal";
import React from "react";

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  plantsPerGreenery: number;
}

export const Component: React.FC<Props> = ({ isOpen, onClose, plantsPerGreenery }) => {
  const renderContent = () => {
    return (
      <div>
        <Typography variant="body1">
          Confirm you want to <strong>spend {plantsPerGreenery} plants to place a greenery</strong>.
        </Typography>
      </div>
    );
  };

  return (
    <DecisionBaseModal.Component
      content={renderContent()}
      isOpen={isOpen}
      onClose={onClose}
      ActionData={{}}
      ActionId="PLANT_GREENERY"
      DecisionId="MAIN_ACTION"
    />
  );
};

Component.displayName = "PlantGreeneryWithPlantsModal";
